// extracted by mini-css-extract-plugin
export default {"loading":"m7j3aHBa6I3RwcjfkB12","loadingIcon":"QApcE9YyRLJ2jYH7jgDL"};